import React from 'react';
import { AuthRoles, Languages } from '../../../config';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Dispatch } from 'redux';
import Actions from '../../../redux/reducers/gl_auth_reducer/actions';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import { Colors } from '../../../styles';
import NavigationConfig from 'navigation/config';

// TDispatc
interface IMenuConfigurationElement {
  label: string;
  id: string;
  action: (props: Dispatch<any>, history: any) => void;
  submenu: boolean;
  roles: Array<number> | number;
  icon: any;
}

export const ProfileConfiguration: IMenuConfigurationElement[] = [
  {
    label: 'Profile',
    id: '1',
    action: (dispatch: Dispatch<any>, history) =>
      history.push(NavigationConfig.dashboardPage().path),
    submenu: false,
    roles: AuthRoles.Registered,
    icon: <PermIdentityIcon />,
  },
  {
    label: 'Logout',
    id: '2',
    action: (dispatch: Dispatch<any>, history) =>
      dispatch(Actions.logoutAction(history)),
    submenu: false,
    roles: AuthRoles.Registered,
    icon: <ExitToAppIcon />,
  },
];

interface IElementConfiguration {
  enable: boolean;
  config?: IConfig;
}

interface IConfiguration {
  sidebar: IElementConfiguration;
  appName: IElementConfiguration;
  search: IElementConfiguration;
  notifications: IElementConfiguration;
  profile: IElementConfiguration;
  language: IElementConfiguration;
  appBar: IElementConfiguration;
}

interface IConfig {
  name?: string;
  color?: string;
  primaryTextColor?: string;
  secondaryTextColor?: string;
  primaryColor?: string;
  secondaryColor?: string;
  sidebarColorBack?: string;
  listSelectedItemColor?: string;
  listSelectedItemColorHover?: string;
  listUnelectedItemColorHover?: string;
  listSelectedItemTextColor?: string;
  listSelectedItemColorTextHover?: string;
  listSelectedItemTextColorSelected?: string;
  iconSrc?: any;
}

const Configuration: IConfiguration = {
  sidebar: {
    enable: true,
    config: {
      color: 'rgba(2, 13, 26, .99)',
      primaryTextColor: Colors.TEXT_COLOR_DARK(1),
      secondaryTextColor: Colors.TEXT_COLOR_DARK(1),
      primaryColor: Colors.APP_COLOR_PRIMARY(),
      secondaryColor: Colors.APP_COLOR_DARK(),
      sidebarColorBack: Colors.APP_COLOR_DARK(0.2),
      listSelectedItemColor: Colors.APP_COLOR_HIGHLIGHT(),
      listSelectedItemColorHover: Colors.APP_COLOR_HIGHLIGHT(0.92),
      listSelectedItemTextColor: Colors.TEXT_COLOR_DARK(1),
      listSelectedItemTextColorSelected: 'white',
      listSelectedItemColorTextHover: Colors.TEXT_COLOR_HIGHLIGHT(0.9),
      listUnelectedItemColorHover: Colors.APP_COLOR_HIGHLIGHT(0.1),
    },
  },
  appBar: {
    enable: true,
    config: {
      color: 'rgba(237, 243, 245, 1)',
      primaryTextColor: 'white',
    },
  },
  appName: {
    enable: true,
    config: {
      name: 'Data Managment Platform',
    },
  },
  search: {
    enable: false,
    config: {},
  },
  notifications: {
    enable: true,
    config: {},
  },
  profile: {
    enable: true,
    config: {
      iconSrc: require('../../../assets/images/logos/logo-oss-white.png'),
    },
  },
  language: {
    enable: false,
  },
};

export default Configuration;
